import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ManagerFeedbackState } from './manager-feedback.reducer';

export const selectManagerFeedbackState = createFeatureSelector<ManagerFeedbackState>('managerFeedback');

// List selectors
export const selectFeedbackList = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.list
);

export const selectPagination = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.pagination
);

export const selectFilters = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.filters
);

// Detail selectors
export const selectSelectedFeedback = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.selectedFeedback
);

export const selectSelectedFeedbackNotes = createSelector(
  selectSelectedFeedback,
  (feedback) => feedback?.notes ?? []
);

// Loading selectors
export const selectLoading = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.loading
);

export const selectDetailLoading = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.detailLoading
);

export const selectIsAnyLoading = createSelector(
  selectLoading,
  selectDetailLoading,
  (loading, detailLoading) => loading || detailLoading
);

// Error selectors
export const selectError = createSelector(
  selectManagerFeedbackState,
  (state: ManagerFeedbackState) => state.error
);
